import React, { useState, useEffect } from "react";
import SuccessAlert from "../SuccessAlert";
import axiosCMS from "../libs/axios/axiosCMS";
import { useDispatch } from "react-redux";
import { addToast } from "../libs/redux/slices/toastSlice";
import Select from "react-select";

const SampleQuestionModal = ({ item, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [question, setQuestion] = useState(item?.question || "");
  const [capability, setCapability] = useState({ label: "Unknown Capability", value: "Unknown Capability" });
  const [capabilities, setCapabilities] = useState([]);
  const [successNotification, setSuccessNotification] = useState("");

  useEffect(() => {
    const fetchCapabilities = async () => {
      try {
        const response = await axiosCMS.get("fallback/get-master-capability/w/not-found");
        if (response.status === 200) {
          const result = await response.data;
          setCapabilities(result.data.map((x) => ({
            value: x,
            label: x,
            disabled: x === "Unknown Capability",
          })));
        }
      } catch (error) {
        console.error("Error fetching capabilities:", error);
      }
    };

    if (isOpen && item) {
      fetchCapabilities();
      setQuestion(item?.question || "");
    }
  }, [isOpen, item]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestBody = {
      question: question,
      detected_capability: item.detected_capability,
      capability_function: capability.value,
      doc_id: item.id,
    };

    try {
      const response = await axiosCMS.post("fallback/create-sample-question", requestBody);

      if (response.status === 200) {
        dispatch(addToast({
          type: "success",
          title: "Changes was successfully saved"
        }))
        // Delay closing the modal to allow the success alert to be visible
        onClose();
      }
    } catch (error) {
      console.error("Failed to create sample question. ", error);
      dispatch(addToast({
        type: "error",
        title: "Failed to add sample question"
      }))
    }
  };

  const handleInputChange = (key, selectedOptions) => {
    setCapability(selectedOptions);
  };

  const handleUpdateSuccess = (message) => {
    setSuccessNotification(message);
    setTimeout(() => setSuccessNotification(""), 5000); // Success alert auto-closes after 5 seconds
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {successNotification && (
          <SuccessAlert
            message={successNotification}
            onClose={() => setSuccessNotification("")}
          />
        )}
        <form onSubmit={handleSubmit} className="modal-form">
          <h2 className="modal-title">Add Sample Question</h2>
          <hr className="modal-separator" />
          <div className="modal-form-group">
            <label htmlFor="question">Question</label>
            <input
              id="question"
              type="text"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              required
            />
          </div>
          <div className="modal-form-group">
            <label htmlFor="detected_capability">Detected Capability</label>
            <input
              id="detected_capability"
              type="text"
              value={item.detected_capability}
              className="suggested-cap-input"
              readOnly
            />
          </div>
          <div className="modal-form-group">
            <label htmlFor="capability">Capability/Function</label>
            <Select
              id="capability"
              name="capability"
              options={capabilities}
              value={capability}
              onChange={(selectedOptions) =>
                handleInputChange("capability", selectedOptions)
              }
              isOptionDisabled={(capability) => capability.disabled}
              className="multi-select"
              classNamePrefix="select"
            />
          </div>
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SampleQuestionModal;
